module.exports = __webpack_public_path__ + "static/media/Download-World-PNG-Free-Download.ef22a519.png";